import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import BasePage from "../../../Components/Base/BasePage";
import GridEmViagemTab from "./GridEmViagemTab";
import GridNaoIniciadasTab from "./GridNaoIniciadasTab";
import MapaLogisticoTab from "./MapaLogisticoTab";

const GridViagemPage = (props: any) => {
	const [labelNaoIniciadas, setLabelIniciadas] = useState(`Não Iniciadas`);
	const [labelEmViagem, setLabelEmViagem] = useState(`Em Viagem`);
	const [labelMapaLogistico, setLabelMapaLogistico] = useState(`Mapa Logístico`);
	const [menuItems, setMenuItems] = useState<any[]>([]);
	
	const [usuario, setUsuario] = useState<any | null>(() => {
		const usuario = localStorage.getItem("user");
		return usuario ? JSON.parse(usuario) : [];
	});

	useEffect(() => {
		let items = [];
		if (usuario.ver_grid_nao_iniciada) {
			items.push({
				key: 'tabNaoIniciadas',
				label: labelNaoIniciadas,
				children: <GridNaoIniciadasTab setLabel={setLabelIniciadas} />,
			});
		}
		
		if (usuario.ver_grid_em_viagem) {
			items.push({
				key: 'tabEmViagem',
				label: labelEmViagem,
				children: <GridEmViagemTab setLabel={setLabelEmViagem} />,
			});
		}

		items.push({
			key: 'tabMapaLogistico',
			label: labelMapaLogistico,
			children: <MapaLogisticoTab />,
		});

		setMenuItems(items);
	}, []);

	return (
		<BasePage>
			<Tabs defaultActiveKey={'tabEmViagem'} items={menuItems} onChange={(e) => console.log(e)} />
		</BasePage>
	);
}

export default GridViagemPage;